import React, { useMemo } from "react";
import Link from "next/link";
import fileDownload from "js-file-download";
import { splitTitle } from "utils/utils";

const _CheckTagToUse = ({ external, download, href, children, ...rest }) => {
  return download ? (
    <div
      onClick={() => {
        const handleDownload = (url) => {
          const name = url.split("/");
          try {
            fetch(url, {
              mode: "cors",
            })
              .then((response) => response.blob())
              .then((blob) => {
                fileDownload(blob, `thriveAgric-${name[name.length - 1]}`);
              });
          } catch (e) {
            console.log(e);
          }
        };
        handleDownload(href);
      }}
    >
      {children}
    </div>
  ) : external ? (
    <a {...rest} href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  ) : (
    <Link href={href} {...rest}>
      {children}
    </Link>
  );
};
const SubResult = ({
  imgSrc,
  category,
  date,
  topic,
  link,
  external,
  download,
}) => {
  let formatDate = new Date(date).toDateString().split("").slice(4);
  const { mainTitle, subLink } = useMemo(() => {
    return splitTitle({ title: topic });
  }, [topic]);
  return (
    <_CheckTagToUse
      external={external}
      download={download}
      href={subLink || link}
    >
      {/* INFO: this was resulting in build error */}

      <div className="cursor-pointer hover:text-primary transition-all">
        <figure className="relative w-full h-[200px] overflow-hidden">
          {/* eslint-disable-next-line @next/next/no-img-element*/}
          <img
            src={imgSrc}
            alt="blog img"
            className="object-cover object-center w-full h-full transition-all hover:scale-105"
          />
          {category && (
            <figcaption className="left-4 text-white text-sm bg-primary min-w-[200px] absolute bottom-0 flex font-bold text-left p-2">
              {category}
            </figcaption>
          )}
        </figure>
        <div className="h-full p-4">
          <p className="text-sm font-normal">{formatDate}</p>
          <h4 className="font-bold text-left text-h4">{mainTitle}</h4>
        </div>
      </div>
    </_CheckTagToUse>
  );
};

export default SubResult;
